/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const strings = pickLocale(ar.strings, en.strings)

/** The reports screen keeps its own block — a different screen, a different vocabulary. */
export const reportsStrings = pickLocale(ar.reportsStrings, en.reportsStrings)
